import React, { MouseEvent, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";
import { toast } from "sonner";

interface Props {
  setIsModalOpen: (isOpen: boolean) => void;
}

const ImportModal: React.FC<Props> = ({ setIsModalOpen }) => {
  const [eid, setEid] = useState("");

  const handleImport = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!eid.trim()) return;
    try {
      setIsModalOpen(false);
      toast.success("Product imported successfully!");
    } catch (err) {
      console.error(err);
    }
  };

  const handleModalClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) setIsModalOpen(false);
  };

  return (
    <div
      className="fixed top-0 left-0 z-50 w-full h-full bg-black/20 flex items-center justify-center"
      onClick={handleModalClick}
    >
      <div className="bg-white rounded-2xl shadow-lg p-8 min-w-[400px] max-w-md w-full flex flex-col gap-4 relative">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">
            Import product from Dippi
          </h2>
          <Button
            type="button"
            variant="ghost"
            onClick={() => setIsModalOpen(false)}
            className="p-2"
          >
            <X />
          </Button>
        </div>
        <p className="text-gray-600 text-sm">
          To import a product from Dippi, please enter the{" "}
          <span className="font-medium">Product ID</span> in the field below.
          You can find the Product ID in your Dippi portal by navigating to your
          Brand's products page. In the products table, each product row
          displays its Product ID (e.g.,{" "}
          <span className="bg-gray-100 px-1 rounded text-xs font-mono">
            KI2
          </span>
          ).
        </p>
        <form onSubmit={handleImport} className="flex flex-col gap-4">
          <Input
            type="text"
            placeholder="Product ID from Dippi (e.g., KI2)"
            value={eid}
            onChange={(e) => setEid(e.target.value)}
            autoFocus
          />
          <Button type="submit" disabled={!eid.trim()} className="w-full">
            Import product
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ImportModal;
